export default "/images/framework/HeroBarCht.c4dba0a3.svg?c4dba0a3";